module.exports = __webpack_public_path__ + "static/media/smile-wink.69658682.svg";